<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" select="news" style="min-width: 1200px"></tab>

    <div>
      <img v-if="curType !== null" :src="curType.img" width="100%" alt="" />
    </div>

    <div class="main flex-row justify-content-spaceBetween align-items-center margin-ts margin-b border-b" style="padding-top: 3vh !important">
      <p class="fs-mid grey">当前位置：<span class="pointer grey" @click="jumpTo('/')">首页</span> > {{ curType.text }}</p>
      <!--      <div class="flex-row justify-content-center border align-items-center searchBox">-->
      <!--        <input type="text" class="fs-mid search margin-r" placeholder="点击输入搜索新闻/关键词" />-->
      <!--        <van-icon name="search" color="#999999" class="margin-l" size="20" />-->
      <!--      </div>-->
    </div>
    <div class="main">
      <p class="fs-superExtraBig fw-mid width-100 textAlign-c lineHeight1 margin-b">{{ news.title }}</p>
      <p class="fs-mid darkgrey width-100 textAlign-c margin-b">
        发布时间：{{ news.createTime }} 来源：{{ news.origin }} 编辑：{{ news.author }} 浏览次数：{{ news.viewNum }}次
      </p>
      <div class="margin-b width-100 fs-mid editor" v-html="news.content"></div>
    </div>
    <backBtn></backBtn>
    <footerBox class="margin-t"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';
import backBtn from '@/components/backBtn.vue';
import newsApi from '@/api/newsApi';
import config from '@/config';
export default {
  name: 'newsDetail',
  components: {
    tab,
    footerBox,
    backBtn
  },
  data() {
    return {
      // id:this.$route.query.id,
      currentPage: 1,
      tabIndex: 0,
      news: {},
      list: [],
      curType: null,
      finishFlag: false,
      mobileMode: false,
      openMenu: true,
      widthLimit: config.widthLimit,
      typeList: [
        {
          type: 'news',
          text: '新闻中心',
          img: require('@/assets/image/banner5.jpg')
        },
        {
          type: 'notice',
          text: '通知公告',
          img: require('@/assets/image/banner2.jpg')
        },
        {
          type: 'enterprise',
          text: '下属企业',
          img: require('@/assets/image/banner4.jpg')
        },
        {
          type: 'profile',
          text: '投资项目',
          img: require('@/assets/image/banner3.jpg')
        },
        {
          type: 'project',
          text: '专题专栏',
          img: require('@/assets/image/banner7.jpg')
        }
      ]
    };
  },
  watch: {
    finishFlag(newVal) {
      this.finish(newVal);
    },
    offsetWidth(val) {
      console.log(val);
      this.mobileMode = val < this.widthLimit;
    }
  },
  created() {
    this.offsetWidth = document.body.offsetWidth;
    this.mobileMode = this.offsetWidth < this.widthLimit;

    window.onresize = () => {
      return (() => {
        this.offsetWidth = document.body.offsetWidth;
      })();
    };
    let type = this.$route.query.type;
    this.typeList.forEach((item) => {
      if (item.type === type) {
        this.curType = item;
      }
    });
    newsApi
      .one(this.$route.query.newsId)
      .then((res) => {
        this.news = res.data;
        // 增加点击量
        document.title = this.news.title;
        this.finishFlag = true;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {},
  methods: {
    finish(val) {
      console.log(val);
    },
    select(e) {
      this.tabIndex = e;
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .editor p {
  line-height: 30px;
  img {
    max-width: 1200px;
  }
}

.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 7vh;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}
.tab {
  height: 50px;
  width: 100%;
  line-height: 50px;
  text-align: center;
  border-bottom: 1px solid #eeeeee;
}
.tab_avtive {
  background: rgb(11, 73, 158) !important;
  border-left: 6px solid rgb(204, 58, 58);
  color: white;
  border-bottom: none;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
.box {
  height: 140px;
}
.leftBox {
  width: 17%;
  margin-right: 3%;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
.ql-editor {
  line-height: 2em;
}
.ql-editor > p {
  /*margin: 2em 0;*/
  margin-bottom: 2em;
}
/*.ql-editor>p>span{*/
/*    margin: 2em 0;*/
/*}*/
</style>
